import moment = require("moment");

import { IEvent, IMonth } from "../../interfaces";
import { ICalendarFilterState, defaultCalendarFiltersState } from "./calendar-filter.state";
import { IStartupState, defaultStartupState } from "./startup.state";
import { IMiniCalendarState } from "./mini-calendar.state";
import { IEventFilter } from '../../classes/calendar';

/**
 * Combine various types into a global Calendar State object.
 */
export interface ICalendarState<T extends IEvent> extends ICalendarFilterState<T>, IMiniCalendarState {
    openModalTrigger: HTMLButtonElement | undefined;
    updating: boolean;
    currentScrolledDate: moment.Moment;
    currentDate: moment.Moment;
    miniCalendarDateSelected: boolean;
    miniCalendarDate: moment.Moment;
    startDate: moment.Moment;
    endDate: moment.Moment;
    dateRangeFromQueryString: boolean;
    events: IMonth<T>[];
    firstMonthEvents: IMonth<T>[];
    filteredEvents: IMonth<T>[];
    filteredNextMonthEvents: IMonth<T>[];
    loadedMonths: string[];
    allEventTypes: string[];
    availableEventTypes: string[];
    selectedEventType: string;
    monthToLoad: string;
    apiError: any;
    startupState: IStartupState | null;
    eventFilter: IEventFilter[];
    filterFunction: (event: IEvent) => boolean;

}

// Check startup state when initially constructing the defaultCalendarState
const startDate = moment(defaultStartupState.startDate);
const endDate = moment(defaultStartupState.endDate);
const dateRangeFromQueryString = defaultStartupState.dateRangeFromQueryString;
const thisMonth = moment(defaultStartupState.currentDate).startOf('month');

//const monthsToLoad: string[] = (() => {
//    const monthsToLoad: string[] = [thisMonth.format('YYYY-MM-DD')];
//    if (endDate.clone().startOf('month').isAfter(thisMonth)) {
//        const yearDiff = endDate.year() - thisMonth.year();
//        const monthDiff = yearDiff * 12 + endDate.month() - thisMonth.month();
//        for (let i = 1; i <= monthDiff; i++) {
//            monthsToLoad.push(thisMonth.clone().add(i, 'months').format('YYYY-MM-DD'));
//        }
//    }
//    return monthsToLoad;
//})();

const currentDate: moment.Moment = !!defaultStartupState && defaultStartupState.currentDate !== null ? moment(defaultStartupState.currentDate) : startDate.clone();

export const defaultCalendarState: ICalendarState<IEvent> = {
    ...defaultCalendarFiltersState,
    openModalTrigger: undefined,
    updating: true,
    currentDate,
    currentScrolledDate: currentDate.clone().startOf('month'),
    eventFilter: [],
    events: [],
    firstMonthEvents:[],
    allEventTypes: [],
    availableEventTypes: [],
    selectedEventType: '',
    miniCalendarDateSelected: false,
    filteredNextMonthEvents: [],
    miniCalendarDate: null,
    filteredEvents: [],
    loadedMonths: [],
    monthToLoad: thisMonth.format('YYYY-MM-DD'),
    apiError: null,
    startDate: startDate.clone(),
    endDate: endDate.clone(),
    dateRangeFromQueryString,
    currentMonth: startDate.clone().startOf('month'),
    miniCalDialogOpen: false,
    startupState: defaultStartupState,
    filterFunction: () => { return true; },
};